/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */

export type ProprietaMisurataTypeUnitPosition =
  (typeof ProprietaMisurataTypeUnitPosition)[keyof typeof ProprietaMisurataTypeUnitPosition];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProprietaMisurataTypeUnitPosition = {
  Left: "Left",
  Right: "Right",
} as const;
